/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplierBatchListItemDto } from './SupplierBatchListItemDto';
import {
    SupplierBatchListItemDtoFromJSON,
    SupplierBatchListItemDtoFromJSONTyped,
    SupplierBatchListItemDtoToJSON,
} from './SupplierBatchListItemDto';

/**
 * 
 * @export
 * @interface SupplierBatchListResponseDto
 */
export interface SupplierBatchListResponseDto {
    /**
     * 
     * @type {Array<SupplierBatchListItemDto>}
     * @memberof SupplierBatchListResponseDto
     */
    data: Array<SupplierBatchListItemDto>;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchListResponseDto
     */
    queryCount: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchListResponseDto
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierBatchListResponseDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the SupplierBatchListResponseDto interface.
 */
export function instanceOfSupplierBatchListResponseDto(value: object): value is SupplierBatchListResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('queryCount' in value) || value['queryCount'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function SupplierBatchListResponseDtoFromJSON(json: any): SupplierBatchListResponseDto {
    return SupplierBatchListResponseDtoFromJSONTyped(json, false);
}

export function SupplierBatchListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierBatchListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SupplierBatchListItemDtoFromJSON)),
        'queryCount': json['queryCount'],
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
    };
}

export function SupplierBatchListResponseDtoToJSON(value?: SupplierBatchListResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(SupplierBatchListItemDtoToJSON)),
        'queryCount': value['queryCount'],
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
    };
}

